module.exports = __webpack_public_path__ + "img/role-junior.be5f6625.png";